import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckedIcon = _resolveComponent("CheckedIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox", {checked: _ctx.modelValue}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toogle()))
  }, [
    _createVNode(_component_CheckedIcon)
  ], 2))
}